import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=f6d49e68&scoped=true&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=f6d49e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d49e68",
  null
  
)

export default component.exports